import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/auth.service';
import { ToastService } from '../services/toast-service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private authenticationService: AuthenticationService, private toast: ToastService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401 || err.status === 403) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                location.reload();
            }
            let errorMsg = '';
            if (err.error instanceof ErrorEvent) {
                console.log('This is client side error');
                errorMsg = `Error: ${err.error.message}`;
            } else if (typeof err.error === 'string') {
                console.log('This is API error');
                errorMsg = `Error: ${err.error}`;
            } else {
                console.log('This is server side error');
                errorMsg = `Error Code: ${err.status},  Message: ${err.message}`;
            }
            this.toast.showDanger(errorMsg);
            return throwError(errorMsg);
        }))
    }
}
